import { MarketButton } from '@market/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withI18n } from '@squareup/service-i18n/components';
import {
  RepaymentLimit,
  RepaymentLimitContent,
} from '../repayment-limit-content/RepaymentLimitContent';
import styles from './RepaymentLimitPage.module.css';

const DEFAULT_CUSTOM_PERCENTAGE = 50;

export interface RepaymentLimitPageProps {
  readonly onNext: (limit: RepaymentLimit, customPercentage: number) => void;
}

export const RepaymentLimitPage = ({
  onNext,
}: RepaymentLimitPageProps) => {
  const { t } = useTranslation();
  const [selectedLimit, setSelectedLimit] = useState(RepaymentLimit.StatementBalance);
  const [customPercentage, setCustomPercentage] = useState(DEFAULT_CUSTOM_PERCENTAGE);

  const handleNext = () => {
    onNext(selectedLimit, customPercentage);
  };

  return (
    <div className={styles.content}>
      <h2 className="heading-30">
        {t('bankingShared.creditCard.repaymentLimit.title')}
      </h2>

      <RepaymentLimitContent
        selectedLimit={selectedLimit}
        customPercentage={customPercentage}
        onLimitChange={setSelectedLimit}
        onCustomPercentageChange={setCustomPercentage}
      />

      <MarketButton rank="primary" onClick={handleNext}>
        {t('bankingShared.creditCard.repaymentLimit.next')}
      </MarketButton>
    </div>
  );
};

export const RepaymentLimitPageI18n = withI18n(RepaymentLimitPage);
